import React from 'react';
import PropTypes from 'prop-types';
import { ContentSection } from 'site-modules/shared/components/content-section/content-section';
import { TruncatedText } from 'site-modules/shared/components/truncated-text/truncated-text';
import { MAX_TRUNCATED_SELLER_COMMENTS_CHAR_LIMIT } from 'client/site-modules/shared/constants/private-party/car-details';
import { CREATIVE_ID_SELLER_DESCRIPTION_ENTRY } from 'client/site-modules/shared/constants/private-party/tracking';

export function SellerComments({ isMobile = false, text = '' }) {
  return (
    <ContentSection
      className="w-100"
      dataTrackingParent={CREATIVE_ID_SELLER_DESCRIPTION_ENTRY}
      titleClassName="heading-4 mb-1_5"
      line={false}
      headerTag="h4"
      sectionTitle="Seller Description"
    >
      {isMobile ? (
        <TruncatedText
          btnClassName="heading-5 text-blue-50 mb-0"
          btnTextMore="Read more"
          btnTextLess="Read less"
          className="size-16"
          indicatorOpenClass="icon-arrow-down4 text-blue-50 xsmall ps-0_5"
          indicatorCloseClass="icon-arrow-down4 text-blue-50 xsmall ps-0_5"
          isInlineBtn
          maxTextLength={MAX_TRUNCATED_SELLER_COMMENTS_CHAR_LIMIT}
          text={text}
        />
      ) : (
        text
      )}
    </ContentSection>
  );
}

SellerComments.propTypes = {
  isMobile: PropTypes.bool,
  text: PropTypes.string,
};
